import headerOptions from '../TheHeader/TheHeader.options'

const options = Object.assign({}, headerOptions ,{name: "IndependentHeader"});
export default options